import { DIMENSION_FONT_SIZE } from '@rta/rta-blueprint-library';

export const APPLIANCE_FONT_SIZE = DIMENSION_FONT_SIZE;
